import React, { useEffect, useState } from 'react'
import MentoriaQuestion from '../../organisms/form-mentoria/mentoria-question/mentoriaQuestion';
import './sliderQuestion.scss'
import arrow from "../../../assets/images/icons/chevron-down.svg"

interface SliderQuestionProps {
    formData: any;
    setData: any;
    questions: Array<any>;
    parentId: number;
    key: any;
}

const SliderQuestion = ({ formData, setData, questions, parentId, key }: SliderQuestionProps) => {

    const [questionCounter, setQuestionCounter] = useState(0);
    const [canContinue, setCanContinue] = useState(false);
    const [goBack, setGoBack] = useState(false);

    const movePreviousQuestion = () => {
        setGoBack(true);
        setCanContinue(false);
        setQuestionCounter((questionCounter - 1 < 0 ? 0 : questionCounter - 1))
    };

    const moveNextQuestion = () => {
        if (questionCounter + 1 >= questions.length) {
            setCanContinue(true);
            setData(true, parentId);
            return;
        }
        setQuestionCounter(questionCounter + 1);

    };

    useEffect(() => {
        if (formData[questions[questions.length - 1].id]) {
            setQuestionCounter(questions.length - 1);
            setCanContinue(true);
        }
    }, [])


    useEffect(() => {
        const timeout = setTimeout(() => {

            if (
                !formData[questions[questionCounter].id]
            ) {
                return;
            }

            if (!goBack)
                moveNextQuestion();

            setGoBack(false);
        }, 500);

        return () => {
            clearTimeout(timeout);
        }

    }, [formData[questions[questionCounter].id]])


    return (
        <div
            className="m-sliderQuestion-container"
            key={key}
        >
            <div className="m-sliderQuestion-container__index">
                {questionCounter + 1}
            </div>
            {questionCounter > 0 &&
                <div className="m-sliderQuestion-container__back-button" onClick={movePreviousQuestion}>
                    <img src={arrow} alt="Volver a la pregunta anterior" />
                </div>
            }
            <MentoriaQuestion
                question={questions[questionCounter]}
                value={formData[questions[questionCounter].id]}
                movePreviousQuestion={movePreviousQuestion}
                moveNextQuestion={moveNextQuestion}
                setData={setData}
                isSlider={true}
                sliderMaxValue={100}
                sliderValue={!canContinue ? Math.round((questionCounter / (questions.length)) * 100) : 100}
                formData={formData}
                blobImage={""}
            />
        </div>
    )
}

export default SliderQuestion